<form [formGroup]="form" (ngSubmit)="onSave()" class="formgrid grid">

  <div class="col-12">
    <p class="mt-0 mb-2 text-sm text-600">{{ fragment.description }}</p>
    <p *ngIf="allowedVars.length" class="mt-0 mb-3 text-xs text-500">
      Fill-ins you can use:
      <span class="font-mono">{{ '{' }}{{ allowedVars.join('} {') }}{{ '}' }}</span>
      — each is replaced with the page's own value.
    </p>
  </div>

  <div class="col-12">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Sentence</h3>
    <textarea pInputTextarea formControlName="copy" rows="4" class="inputfield w-full"
      [ngClass]="{ 'ng-invalid ng-dirty': form.get('copy')?.invalid && form.get('copy')?.touched }"></textarea>
    <small class="block text-500 mt-1">
      Shown on every page that uses this sentence — keep it one or two plain sentences.
    </small>
  </div>

  <div class="col-12">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Image <span class="text-500 text-sm font-normal">(only where this fragment's spot on the site shows one)</span></h3>
    <div class="flex align-items-center gap-3">
      <img *ngIf="imagePreview" [src]="imagePreview" alt="Image preview" style="height: 48px; width: auto; border-radius: 6px;" />
      <span *ngIf="!imagePreview && imageFileId" class="text-500 text-sm">Image attached</span>
      <button pButton pRipple type="button" [label]="imageFileId ? 'Replace image' : 'Upload image'" icon="pi pi-upload"
        class="p-button-outlined p-button-sm" (click)="uploadImage()"></button>
      <button *ngIf="imageFileId" pButton pRipple type="button" label="Remove" class="p-button-text p-button-danger p-button-sm"
        (click)="removeImage()"></button>
    </div>
    <small class="block text-500 mt-1">
      When an image is set, the sentence above doubles as its description for screen readers.
      Removing it puts the site's built-in photo back.
    </small>
  </div>

  <div class="col-12 flex justify-content-end gap-2 mt-3">
    <button pButton pRipple type="button" label="Cancel" class="p-button-text" (click)="onCancel()"></button>
    <button pButton pRipple type="submit" label="Save" icon="pi pi-check"></button>
  </div>

</form>
